/* eslint-disable class-methods-use-this */
import { observable, action } from 'mobx';
import { ServiceListItem } from '@/pages/home/type/serviceManage';
import { Pagination } from '@/typings/common';
import {
  getServiceList, createServiceGroup,
  editServiceGroup, getBusinessList,
  deleteDocPlatform,
} from '../server/serviceManage';
import i18next from 'i18next';
import errCode from '@/utils/request/errCode';
import { get } from 'lodash';
import Message from '@/component/Message';

class ProjectStore {
  @observable businessList: {id: number; name: string}[] = [];

  @observable serviceList: ServiceListItem[] = [];

  @observable pagination: Pagination = {
    page: 1,
    totalNumber: 0,
    totalPage: 0,
  };

  @observable serviceListLoading = 'loading';

  @observable showModal = false;

  @observable currentService: ServiceListItem | null = null;

  @action
  async updateService(data: any, success: any) {
    const { business, serviceId, teamId } = data;
    try {
      const task = serviceId ? editServiceGroup : createServiceGroup;
      const { code, msg } = await task({
        ...data,
        business: String(business),
      });
      if (code === errCode.SUCCESS) {
        Message.success(serviceId ? i18next.t('update_success') : i18next.t('create_success'));
        success();
        this.getServices(teamId);
        return true;
      }
      if (code === 40109) {
        Message.error('PSM已经被创建');
        return;
      }
      Message.error(msg);
      return false;
    } catch (e) {
      return false;
    }
  }

  @action
  async getServices(teamId: string) {
    this.serviceList = [];
    this.serviceListLoading = 'loading';
    try {
      const { data, code } = await getServiceList({
        page: this.pagination.page,
        pageSize: 12,
        teamId,
      });
      if (code === errCode.SUCCESS) {
        this.serviceList = data.serviceList || [];
        this.pagination = {
          ...this.pagination,
          ...data.pageInfo,
        };
        return;
      }
      Message.error(i18next.t('get_service_list_error'));
    } finally {
      this.serviceListLoading = 'success';
    }
  }

  @action
  async getBusinessList() {
    const result = await getBusinessList();
    this.businessList = get(result, 'data.businessList', []);
  }

  @action
  async deleteDocPlatform(serviceId: string) {
    const result = await deleteDocPlatform({ serviceId });
    if (result.code !== errCode.SUCCESS) {
      Message.error(i18next.t('delete_platfrom_error'));
      return Promise.resolve('error');
    }
    Message.success(i18next.t('delete_platfrom_success'));
    const index = this.serviceList.findIndex((item) => item.serviceId === serviceId);
    this.serviceList.splice(index, 1);
    return Promise.resolve('success');
  }
}

export default { name: 'projectStore', Store: ProjectStore };
